import React, { useState, useCallback, useEffect } from 'react';

const fmt = (n) => Number(n || 0).toFixed(2);

// Formatuje datę używając lokalnych składowych (bez konwersji do UTC),
// żeby uniknąć przesunięcia o dzień w strefach czasowych innych niż UTC.
function toLocalISO(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function today() {
  return toLocalISO(new Date());
}

function monthStart() {
  const d = new Date();
  d.setDate(1);
  return toLocalISO(d);
}

export default function Payroll() {
  const [from, setFrom]         = useState(monthStart());
  const [to, setTo]             = useState(today());
  const [data, setData]         = useState(null);
  const [loading, setLoading]   = useState(false);
  const [toast, setToast]       = useState('');
  const [expanded, setExpanded] = useState(null); // user_id
  const token = window.__cafeApiToken || localStorage.getItem('cafepos_token');

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 2500); };

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`/api/attendance/payroll?from=${from}&to=${to}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const json = await r.json();
      if (!r.ok) throw new Error(json.error);
      setData(json);
      setExpanded(null);
    } catch (err) { showToast('Błąd: ' + err.message); }
    finally { setLoading(false); }
  }, [from, to, token]);

  return (
    <div style={{ padding: 24, maxWidth: 800 }}>
      <h2 style={{ fontSize: 18, fontWeight: 500, marginBottom: 4 }}>💵 Wynagrodzenia</h2>
      <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 20 }}>
        Wyliczane na podstawie ewidencji czasu pracy i stawki godzinowej
      </p>

      <div style={{ display: 'flex', gap: 10, alignItems: 'flex-end', marginBottom: 20, background: 'var(--surface)', border: '0.5px solid var(--border)', borderRadius: 10, padding: '14px 16px', flexWrap: 'wrap' }}>
        <div className="field" style={{ margin: 0, flex: 1, minWidth: 140 }}>
          <label>Od</label>
          <input type="date" value={from} onChange={e => setFrom(e.target.value)} />
        </div>
        <div className="field" style={{ margin: 0, flex: 1, minWidth: 140 }}>
          <label>Do</label>
          <input type="date" value={to} onChange={e => setTo(e.target.value)} />
        </div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <button className="btn-sm" onClick={() => { setFrom(monthStart()); setTo(today()); }}>Ten miesiąc</button>
          <button className="btn-sm" onClick={() => {
            const now = new Date();
            const year = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
            const month = now.getMonth() === 0 ? 11 : now.getMonth() - 1;
            const s = toLocalISO(new Date(year, month, 1));
            const e = toLocalISO(new Date(year, month + 1, 0));
            setFrom(s); setTo(e);
          }}>Poprzedni miesiąc</button>
          <button className="btn-sm" onClick={() => {
            const now = new Date();
            const dow = (now.getDay() + 6) % 7; // poniedziałek = 0
            const monday = new Date(now); monday.setDate(now.getDate() - dow);
            const sunday = new Date(monday); sunday.setDate(monday.getDate() + 6);
            setFrom(toLocalISO(monday)); setTo(toLocalISO(sunday));
          }}>Ten tydzień</button>
          <button className="btn-sm" onClick={() => {
            const now = new Date();
            const dow = (now.getDay() + 6) % 7;
            const thisMonday = new Date(now); thisMonday.setDate(now.getDate() - dow);
            const prevMonday = new Date(thisMonday); prevMonday.setDate(thisMonday.getDate() - 7);
            const prevSunday = new Date(prevMonday); prevSunday.setDate(prevMonday.getDate() + 6);
            setFrom(toLocalISO(prevMonday)); setTo(toLocalISO(prevSunday));
          }}>Poprzedni tydzień</button>
        </div>
        <button className="btn-primary" style={{ width: 'auto', padding: '9px 20px' }} onClick={load} disabled={loading}>
          {loading ? 'Liczenie...' : 'Wylicz'}
        </button>
      </div>

      {data && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 10, marginBottom: 20 }}>
            <div style={{ background: 'var(--bg)', borderRadius: 8, padding: '12px 14px' }}>
              <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Łącznie godzin</div>
              <div style={{ fontSize: 22, fontWeight: 600 }}>{fmt(data.total_hours)} h</div>
            </div>
            <div style={{ background: 'var(--bg)', borderRadius: 8, padding: '12px 14px' }}>
              <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Łączna kwota</div>
              <div style={{ fontSize: 22, fontWeight: 600 }}>{fmt(data.total_amount)} zł</div>
            </div>
          </div>

          <div style={{ background: 'var(--surface)', border: '0.5px solid var(--border)', borderRadius: 10, overflow: 'hidden' }}>
            {data.employees.length === 0 ? (
              <div style={{ padding: 24, textAlign: 'center', color: 'var(--text-muted)' }}>Brak danych</div>
            ) : data.employees.map(e => {
              const isOpen = expanded === e.user_id;
              return (
                <div key={e.user_id} style={{ background: 'var(--surface)', border: '0.5px solid var(--border)', borderRadius: 10, marginBottom: 8, overflow: 'hidden' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', cursor: 'pointer' }}
                    onClick={() => setExpanded(isOpen ? null : e.user_id)}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 14, fontWeight: 500 }}>{e.full_name}</div>
                      <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>
                        {e.hours} h{e.hourly_rate !== null ? ` × ${fmt(e.hourly_rate)} zł/h` : ' · brak stawki'}
                      </div>
                    </div>
                    <div style={{ fontSize: 15, fontWeight: 600, minWidth: 80, textAlign: 'right', color: e.amount === null ? 'var(--text-muted)' : 'var(--text)' }}>
                      {e.amount !== null ? `${fmt(e.amount)} zł` : '—'}
                    </div>
                    <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{isOpen ? '▲' : '▼'}</span>
                  </div>
                  {isOpen && (
                    <div style={{ borderTop: '0.5px solid var(--border)', padding: '10px 16px' }}>
                      <AttendanceDetail employee={e} from={from} to={to} />
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 14 }}>
            Godziny liczone jako suma sesji (zameldowanie → wymeldowanie) pomniejszona o przerwy, przycięta do wybranego okresu.
            Pracownicy bez ustawionej stawki godzinowej (w module Użytkownicy) mają kwotę nieobliczoną.
          </div>
        </>
      )}

      {toast && <div className="toast">{toast}</div>}
    </div>
  );
}

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------
const TYPE_ICONS = {
  clock_in:    { icon: '→', label: 'Zameldowanie',  color: '#16a34a' },
  clock_out:   { icon: '←', label: 'Wymeldowanie',  color: '#dc2626' },
  break_start: { icon: '⏸', label: 'Przerwa start', color: '#854F0B' },
  break_end:   { icon: '▶', label: 'Przerwa koniec',color: '#185FA5' },
};

function groupByDay(events) {
  const groups = {};
  const order = [];
  events.forEach(ev => {
    const d = new Date(ev.created_at);
    const key = d.toLocaleDateString('pl-PL', { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' });
    if (!groups[key]) { groups[key] = []; order.push(key); }
    groups[key].push(ev);
  });
  return { groups, order };
}

function calcWorkedMs(chrono) {
  let workedMs = 0, sessionStart = null, breakStart = null;
  for (const ev of chrono) {
    const t = new Date(ev.created_at).getTime();
    if (ev.type === 'clock_in') { sessionStart = t; }
    else if (ev.type === 'clock_out') {
      if (sessionStart !== null) { workedMs += t - sessionStart; sessionStart = null; }
      breakStart = null;
    } else if (ev.type === 'break_start') { breakStart = t; }
    else if (ev.type === 'break_end') {
      if (breakStart !== null) { workedMs -= t - breakStart; breakStart = null; }
    }
  }
  return Math.max(0, workedMs);
}

function formatDuration(ms) {
  const totalMin = Math.round(ms / 60000);
  const h = Math.floor(totalMin / 60), m = totalMin % 60;
  if (h === 0) return `${m} min`;
  return `${h} godz.${m > 0 ? ` ${m} min` : ''}`;
}

// ---------------------------------------------------------------------------
// AttendanceDetail — rozwijany widok szczegółów pracownika
// ---------------------------------------------------------------------------
function AttendanceDetail({ employee, from, to }) {
  const [events, setEvents]       = useState(null);
  const [dayModal, setDayModal]   = useState(null); // { day, events }
  const [editModal, setEditModal] = useState(null);
  const token = window.__cafeApiToken || localStorage.getItem('cafepos_token');

  function load() {
    fetch(`/api/attendance/detail/${employee.user_id}?from=${from}&to=${to}`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then(r => r.json()).then(setEvents).catch(() => setEvents([]));
  }

  useEffect(() => { load(); }, [employee.user_id, from, to]);

  function toggleDay(key) {
    setExpanded(prev => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  }

  async function handleSave(eventId, newDatetime) {
    await fetch(`/api/attendance/${eventId}`, {
      method: 'PATCH',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ created_at: newDatetime }),
    });
    setEditModal(null);
    load();
  }

  if (!events) return <div style={{ padding: 8, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13 }}>Ładowanie...</div>;

  const { groups, order: allOrder } = groupByDay(events);
  const fromDate = new Date(from + 'T00:00:00');
  const order = allOrder.filter(day => {
    const parts = day.match(/(\d{2})\.(\d{2})\.(\d{4})/);
    if (!parts) return true;
    const d = new Date(`${parts[3]}-${parts[2]}-${parts[1]}T00:00:00`);
    return d >= fromDate;
  });

  if (order.length === 0) return <div style={{ padding: 8, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13 }}>Brak zdarzeń w wybranym okresie</div>;

  return (
    <div>
      {order.map((day, gi) => {
        const dayEvents = groups[day];
        const workedMs = calcWorkedMs(dayEvents);
        const hasMissingClockOut = dayEvents.some(e => e.type === 'clock_in') && !dayEvents.some(e => e.type === 'clock_out');
        return (
          <div key={day} onClick={() => setDayModal({ day, events: dayEvents })}
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 16px', cursor: 'pointer', borderBottom: gi < order.length - 1 ? '0.5px solid var(--border)' : 'none' }}>
            <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.04em' }}>{day}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              {hasMissingClockOut && (
                <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 20, background: '#fffbeb', color: '#854F0B', fontWeight: 500 }}>brak wymeldowania</span>
              )}
              {(() => {
                const clockIn  = dayEvents.find(e => e.type === 'clock_in');
                const clockOut = dayEvents.filter(e => e.type === 'clock_out').pop();
                const fmtT = t => new Date(t).toLocaleTimeString('pl-PL', { hour: '2-digit', minute: '2-digit' });
                return (
                  <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                    {clockIn ? fmtT(clockIn.created_at) : '?'}
                    {' — '}
                    {clockOut ? fmtT(clockOut.created_at) : '?'}
                  </span>
                );
              })()}
              <span style={{ fontSize: 13, fontWeight: 500, color: 'var(--text)' }}>{workedMs > 0 ? formatDuration(workedMs) : '—'}</span>
            </div>
          </div>
        );
      })}

      {dayModal && (
        <DayEventsModal day={dayModal.day} events={dayModal.events} employee={employee}
          onEdit={ev => setEditModal({ event: ev })}
          onAdd={async (data) => {
            const token = window.__cafeApiToken || localStorage.getItem('cafepos_token');
            await fetch('/api/attendance', {
              method: 'POST',
              headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
              body: JSON.stringify({ user_id: employee.user_id, ...data }),
            });
            load();
            setDayModal(null);
          }}
          onClose={() => setDayModal(null)} />
      )}
      {editModal && (
        <EditEventModal event={editModal.event} onSave={handleSave} onClose={() => setEditModal(null)} />
      )}
    </div>
  );
}

function DayEventsModal({ day, events, onEdit, onClose, onAdd, employee }) {
  const [addMode, setAddMode] = React.useState(false);
  const [addForm, setAddForm] = React.useState({ type: 'clock_in', date: '', time: '' });
  const [adding, setAdding] = React.useState(false);

  async function submitAdd() {
    if (!addForm.date || !addForm.time) return;
    setAdding(true);
    await onAdd({ type: addForm.type, created_at: `${addForm.date} ${addForm.time}:00` });
    setAddMode(false);
    setAdding(false);
  }
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 400 }}>
      <div style={{ background: 'var(--surface)', borderRadius: 12, padding: 24, width: 420, maxWidth: '90vw' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
          <h3 style={{ fontSize: 15, fontWeight: 600 }}>{day}</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: 'var(--text-muted)' }}>×</button>
        </div>
        {employee && (
          <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 14 }}>
            {employee.full_name}
            {employee.hourly_rate !== null && <span style={{ marginLeft: 8, color: 'var(--blue)', fontWeight: 500 }}>{fmt(employee.hourly_rate)} zł/h</span>}
          </div>
        )}
        <div style={{ border: '0.5px solid var(--border)', borderRadius: 8, overflow: 'hidden' }}>
          {events.map((ev, i) => {
            const meta = TYPE_ICONS[ev.type] || { icon: '•', label: ev.type, color: 'var(--text-muted)' };
            const time = new Date(ev.created_at).toLocaleTimeString('pl-PL', { hour: '2-digit', minute: '2-digit' });
            const date = new Date(ev.created_at).toLocaleDateString('pl-PL', { day: '2-digit', month: '2-digit' });
            return (
              <div key={ev.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '11px 14px', borderBottom: i < events.length - 1 ? '0.5px solid var(--border)' : 'none' }}>
                <span style={{ fontSize: 16, color: meta.color, minWidth: 20, textAlign: 'center' }}>{meta.icon}</span>
                <span style={{ flex: 1, fontSize: 13 }}>{meta.label}</span>
                <span style={{ fontSize: 13, color: 'var(--text-muted)', marginRight: 4 }}>{date}</span>
                <span style={{ fontSize: 13, fontWeight: 500, marginRight: 12 }}>{time}</span>
                <button onClick={() => onEdit(ev)}
                  style={{ padding: '4px 10px', border: '0.5px solid var(--border)', borderRadius: 6, background: 'none', cursor: 'pointer', fontSize: 12, color: 'var(--text-muted)' }}>
                  ✏️ Koryguj
                </button>
              </div>
            );
          })}
        </div>
        {!addMode ? (
          <button onClick={() => {
            const parts = day.match(/(\d{2})\.(\d{2})\.(\d{4})/);
            const d = parts ? `${parts[3]}-${parts[2]}-${parts[1]}` : '';
            setAddForm({ type: 'clock_in', date: d, time: '' });
            setAddMode(true);
          }}
            style={{ width: '100%', marginTop: 10, padding: '10px', border: '0.5px solid var(--border)', borderRadius: 8, background: 'none', cursor: 'pointer', fontSize: 13, color: 'var(--text-muted)' }}>
            + Dodaj zdarzenie
          </button>
        ) : (
          <div style={{ marginTop: 12, border: '0.5px solid var(--border)', borderRadius: 8, padding: 14 }}>
            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 10 }}>Nowe zdarzenie</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginBottom: 10 }}>
              <div className="field" style={{ margin: 0, gridColumn: '1/-1' }}>
                <label>Typ</label>
                <select value={addForm.type} onChange={e => setAddForm(f => ({ ...f, type: e.target.value }))}
                  style={{ width: '100%', padding: '8px 10px', border: '0.5px solid var(--border)', borderRadius: 6, background: 'var(--bg)', fontSize: 13 }}>
                  <option value="clock_in">Zameldowanie</option>
                  <option value="clock_out">Wymeldowanie</option>
                  <option value="break_start">Rozpoczęcie przerwy</option>
                  <option value="break_end">Zakończenie przerwy</option>
                </select>
              </div>
              <div className="field" style={{ margin: 0 }}>
                <label>Data</label>
                <input type="date" value={addForm.date} onChange={e => setAddForm(f => ({ ...f, date: e.target.value }))} />
              </div>
              <div className="field" style={{ margin: 0, gridColumn: '2/-1' }}>
                <label>Godzina</label>
                <input type="time" value={addForm.time} onChange={e => setAddForm(f => ({ ...f, time: e.target.value }))} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => setAddMode(false)}
                style={{ flex: 1, padding: '9px', border: '0.5px solid var(--border)', borderRadius: 6, background: 'none', cursor: 'pointer', fontSize: 13, color: 'var(--text-muted)' }}>
                Anuluj
              </button>
              <button onClick={submitAdd} disabled={adding || !addForm.date || !addForm.time}
                style={{ flex: 2, padding: '9px', border: 'none', borderRadius: 6, background: 'var(--blue)', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
                {adding ? 'Dodaję...' : 'Dodaj'}
              </button>
            </div>
          </div>
        )}
        <button onClick={onClose} style={{ width: '100%', marginTop: 10, padding: '11px', border: '0.5px solid var(--border)', borderRadius: 8, background: 'none', cursor: 'pointer', fontSize: 14 }}>
          Zamknij
        </button>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------
// EditEventModal — korekta daty i godziny zdarzenia
// ---------------------------------------------------------------------------
function EditEventModal({ event, onSave, onClose }) {
  const dt = new Date(event.created_at);
  const [date, setDate] = useState(toLocalISO(dt));
  const [time, setTime] = useState(dt.toLocaleTimeString('pl-PL', { hour: '2-digit', minute: '2-digit' }));
  const [saving, setSaving] = useState(false);
  const meta = TYPE_ICONS[event.type] || { label: event.type };

  async function submit() {
    setSaving(true);
    const newDatetime = `${date} ${time}:00`;
    await onSave(event.id, newDatetime);
    setSaving(false);
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 400 }}>
      <div style={{ background: 'var(--surface)', borderRadius: 12, padding: 24, width: 360, maxWidth: '90vw' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h3 style={{ fontSize: 16, fontWeight: 600 }}>✏️ Korekta zdarzenia</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: 'var(--text-muted)' }}>×</button>
        </div>
        <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 16 }}>{meta.label}</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
          <div className="field" style={{ margin: 0 }}>
            <label>Data</label>
            <input type="date" value={date} onChange={e => setDate(e.target.value)} />
          </div>
          <div className="field" style={{ margin: 0 }}>
            <label>Godzina</label>
            <input type="time" value={time} onChange={e => setTime(e.target.value)} />
          </div>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onClose} style={{ flex: 1, padding: '11px', border: '0.5px solid var(--border)', borderRadius: 8, background: 'none', cursor: 'pointer', fontSize: 14, color: 'var(--text-muted)' }}>
            Anuluj
          </button>
          <button onClick={submit} disabled={saving} style={{ flex: 2, padding: '11px', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, background: 'var(--blue)', color: '#fff', cursor: 'pointer' }}>
            {saving ? 'Zapisuję...' : 'Zapisz korektę'}
          </button>
        </div>
      </div>
    </div>
  );
}
